__turbopack_context__.v({
  "root": "ShareWithPicker-module__VVKPia__root",
});
